import React from "react";
import SEOHead from "../components/shared/SEOHead";
import { getPageSEO } from "../utils/seoConfig";
import LandingPageNavbar from "../components/landing-page/LandingPageNavbar";
import Heading from "../components/landing-page/Heading";
import HowWorks from "../components/landing-page/HowWorks";
import { Hero } from "../components/landing-page/Hero";
import AboutSection from "../components/landing-page/AboutSection";
import PartnersTestimonials from "../components/landing-page/PartnersTestimonials";
import Footer from "../components/landing-page/Footer";
import Pricing from "../components/landing-page/Pricing";
import KeyFeaturesSection from "../components/landing-page/KeyFeaturesSection";
import SlideCreationOptions from "../components/landing-page/SlideCreationOptions";
import AddOnSection from "../components/landing-page/AddOnSection";
import SlackIntegration from "../components/landing-page/SlackIntegration";
import PitchZynth from "../components/landing-page/PitchZynth";
import ZynthStats from "../components/landing-page/ZynthStats";
import ZynthWorks from "../components/landing-page/ZynthWorks";
import Companions from "../components/landing-page/Companions";
import SelectPresentationType from '../components/presentation-type/SelectPresentationType';
import PresentationTypePage from "./PresentationType";
import Navbar from "../components/shared/Navbar";

const LandingPage: React.FC = () => {
  const authToken = sessionStorage.getItem("authToken");
  const isLoggedIn = !!authToken;
  sessionStorage.setItem("redirectAfterAuth","/new-presentation")
  return (
    <>
      <SEOHead seo={getPageSEO("newPresentation")} />
      <div className="no-scrollbar no-scrollbar::-webkit-scrollbar">
       {!isLoggedIn && (
       
          <LandingPageNavbar />
       
      )} 
      {isLoggedIn &&(
        <Navbar />
      )}
        <div className={!isLoggedIn ? 'pt-20' : ''}>
        <SelectPresentationType />
      </div>

    {!isLoggedIn && (
       <>
          <div className="h-64 md:hidden"></div>
          <Heading />
          <AboutSection />
          <KeyFeaturesSection />
          <HowWorks />
          <div id="hero-section">
            <Hero />
          </div>
          <SlideCreationOptions />
          <SlackIntegration />
          <AddOnSection />
          <PitchZynth />
          <ZynthStats />
          <Companions />
          <PartnersTestimonials />
          <Footer />
       </>
      )} 
    </div>
    </>
  );
};

export default LandingPage;
